module.exports = __webpack_public_path__ + "media/dorobek/assets/images/login/logo-text-53a66e7247fe6787faef893096f7d096.svg";